import { logEvent } from '@amplitude/analytics-browser';
import { useQueryClient } from '@tanstack/react-query';
import { updateUserPreferences } from '../services/companyUsers';
import { useAppSelector } from '../store';
import { MARIA_TOKEN_QUERY_KEY } from '../services/maria';
import { CountryKeys } from '../types';
import { useTranslation } from './i18n';

export function useUserLocation() {
  const companyUser = useAppSelector((store) => store.companyUser.companyUser);
  const queryClient = useQueryClient();
  const { i18n } = useTranslation();

  async function handleChangeLocation(location: CountryKeys) {
    i18n.changeLanguage(location);
    logEvent('User changed language', { language: location.slice(0, 2) });
    await updateUserPreferences({ language: location.slice(0, 2) });
    queryClient.invalidateQueries({ queryKey: MARIA_TOKEN_QUERY_KEY });
  }

  return {
    location: companyUser?.selectedCompany?.country,
    locale: i18n.language,
    language: i18n.language.substring(0, 2) === 'es' ? 'es' : 'en',
    handleChangeLocation,
  };
}
